// extracted by mini-css-extract-plugin
export default {"tooltip":"gQ-z","arrow":"hQ-z"};